<template>
  <div class="content-wrapper" id="app">
    <div v-if="$store.state.core.loading" class="preloader">
        <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </div>
    <app-header v-if="!$store.state.core.loading && $store.state.core.user && !$store.state.core.user.firstLogin"></app-header>
    <side-menu v-if="!$store.state.core.loading && $store.state.core.user && !$store.state.core.user.firstLogin" class="side-menu"></side-menu>
    <router-view v-if="!$store.state.core.loading" @loading="toggleLoading"></router-view>
    <div class="clear"></div>
  </div>
</template>

<script>
import AppHeader from '@/CORE/components/AppHeader'
import SideMenu from '@/CUSTOM/components/SideMenu'
export default {
  name: 'app',
  components: {AppHeader, SideMenu},
  data () {
    return {
      isLoading: true
    }
  },
  methods: {
    toggleLoading(l){
      this.$store.dispatch('IS_LOADING', l)
    }
  }
}
</script>




// WEBPACK FOOTER //
// App.vue?6ade5e96